import { useCallback, useLayoutEffect } from 'react'

import { useInterceptorServiceWithAccessToken } from '@/hooks/use-interceptor-service-with-access-token'
import { companiesApi } from '@/lib/axios'

type UseCompaniesServiceProps = {
  refetchAccessToken: () => Promise<string | undefined>
  accessToken?: string
}

export function useCompaniesServiceHook({
  accessToken,
  refetchAccessToken,
}: UseCompaniesServiceProps) {
  const onAccessTokenProvider = useCallback(async () => {
    const accessToken = await refetchAccessToken()

    return accessToken
  }, [refetchAccessToken])

  const { perform } = useInterceptorServiceWithAccessToken(
    companiesApi,
    onAccessTokenProvider,
    accessToken,
  )

  useLayoutEffect(() => {
    if (accessToken) return perform()
  }, [accessToken])
}
